export class NoTemplateHTMLContentError extends Error {
    message = 'HTML Template content is empty.';
}
export class NoTemplateObjectError extends Error {
    message = 'Template object is empty.';
}
